import { useEffect, useRef } from 'react';
import { toast } from '@/hooks/use-toast';

export function useCacheResetNotification() {
  const shown = useRef(false);
  
  useEffect(() => {
    if (shown.current) return;
    
    const flag = localStorage.getItem('cache_reset_success');
    if (!flag) return;
    
    shown.current = true;
    localStorage.removeItem('cache_reset_success');
    
    // Задержка 4 сек — даём стартовым toast'ам (подписка, доступ) отработать
    const timer = setTimeout(() => {
      toast({
        title: "✅ Приложение обновлено",
        description: "Кэш очищен, загружена последняя версия.",
        duration: 6000,
      });
    }, 4000);
    
    return () => clearTimeout(timer);
  }, []);
}
